<template>
  <div class="tool-item2">
    <el-dialog
      class="newDialog"
      title="銷售素材"
      :visible.sync="visible"
      height="100%"
      :before-close="handleClose"
    >
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false, //附檔dialog顯示
      tableData: [], //內文檔案資料
      previewvisable: false,
      selectrow: [], //內文選擇列
      brandList: ["TutorABC", "tutorJr"], //品牌選擇
      options: [], //所有目錄結構
      newoptions: [],
      Breadcrumb: [],
      SearchText: "", //目錄搜尋值
      contentShow: false,
    };
  },
  methods: {
    iniData() {
      this.visible = true;
    },
    handleClose(done) {
      done();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Main/ChatToolBar_AttachFileV2.vue